module.exports = __webpack_public_path__ + "static/media/weixiushigukaohebiaozhun.d4958fc8.png";